{
  "name": "@ns/support-hmrc-no-reviewer",
  "version": "1.0.0",
  "description": "No one at a published company can re-score its HMRC trust score: contact the company, then mark it resolved",
  "inputs": {
    "subjectCompanyId": {
      "type": "string"
    },
    "subjectCompanyName": {
      "type": "string"
    }
  },
  "outcomes": {
    "resolved": {}
  }
}
